module.exports = __webpack_public_path__ + "static/media/arrow-left-green-small.4111a9b1.svg";